export enum CONTRACT {
    SELLING = 0,
    SALE,
    RENT,
    AUCTION,
}